
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Coproratecabandbusserviceinkohlapur() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Service in Kolhapur',
        heading: 'etravo :  Corporate Cab and Bus Service in Kolhapur',
        headingDescription: 'eTravo offers reliable Corporate Cab and Bus Services in Kolhapur, catering exclusively to the transportation needs of businesses and enterprises. From executive cabs for client visits and VIP transfers to spacious corporate buses for employee commuting and company events, our services are designed with professionalism and punctuality in mind. With a fleet of clean, well-maintained vehicles and trained chauffeurs, eTravo ensures a safe, efficient, and comfortable travel experience for your workforce and guests across Kolhapur and surrounding areas.',

        top: 'Top Places to Visit in Amravati with etravo',

         "topPlaces": [
    {
      "title": "Mahalakshmi Temple (Ambabai Temple)",
      "description": "Built in the 7th century, the Mahalakshmi Temple is one of the most revered Shakti Peethas in India. Dedicated to Goddess Mahalakshmi, the temple showcases Hemadpanti architecture and houses a 3-foot-tall gemstone idol of the goddess. It's a significant pilgrimage site, especially during festivals like Navratri and Kirnotsav."
    },
    {
      "title": "Panhala Fort",
      "description": "Perched atop the Sahyadri hills, Panhala Fort is the largest fort in the Deccan region. With a rich history involving Maratha rulers and the British, the fort features structures like the Andhar Bavadi (Hidden Well) and Teen Darwaza. It offers panoramic views and insights into India's medieval past."
    },
    {
      "title": "New Palace (Shree Chhatrapati Shahu Museum)",
      "description": "Constructed between 1877 and 1884, the New Palace is an architectural marvel blending Hindu and European styles. The ground floor houses the Shahaji Chhatrapati Museum, displaying royal artifacts, weapons, and memorabilia of the Kolhapur rulers. The palace remains the residence of the royal family."
    },
    {
      "title": "Rankala Lake",
      "description": "Once a stone quarry, Rankala Lake transformed into a freshwater lake after an earthquake in the 9th century. It's a popular spot for boating and horse riding, with attractions like Shalini Palace and Padmaraje Garden nearby. The lake is steeped in local legends and offers serene views."
    },
    {
      "title": "Jyotiba Temple",
      "description": "Situated 18 km from Kolhapur, the Jyotiba Temple is dedicated to Lord Jyotiba, believed to be an incarnation of the Hindu trinity. Perched atop a hill, the temple attracts thousands of devotees, especially during the annual fairs held in April and May."
    },
    {
      "title": "Radhanagari Wildlife Sanctuary",
      "description": "Also known as the 'Bison Sanctuary,' Radhanagari Wildlife Sanctuary spans over 350 square kilometers. It's home to the Indian bison (gaur), leopards, sloth bears, and numerous bird species. The sanctuary, part of the Western Ghats, is a UNESCO World Heritage Site and offers rich biodiversity."
    },
    {
      "title": "Siddhagiri Gramjivan Museum",
      "description": "Located within the Kaneri Math complex, this unique museum depicts rural Indian life through life-size wax statues. It showcases various aspects of village life, including farming, pottery, and traditional professions, providing an immersive experience into India's agrarian culture."
    },
    {
      "title": "Bhavani Mandap",
      "description": "Once the court of the Maratha rulers, Bhavani Mandap is a historic building near the Mahalakshmi Temple. It now serves as a public monument, housing a temple and a small museum. The structure reflects the grandeur of Maratha architecture and history."
    },
    {
      "title": "Shalini Palace",
      "description": "Built in 1931, Shalini Palace is constructed from black stone and Italian marble. Overlooking Rankala Lake, the palace boasts stained glass windows and intricate woodwork. Though it has been converted into a hotel, it remains a testament to Kolhapur's royal heritage."
    },
    {
      "title": "Dajipur Wildlife Sanctuary",
      "description": "Adjacent to the Radhanagari Sanctuary, Dajipur is known for its dense forests and diverse wildlife. It's a haven for nature enthusiasts, offering opportunities to spot species like the Indian bison, deer, and various birds amidst lush greenery."
    }
  ],

     "services": [
    {
      "name": "Company Cab & Bus Hire in Kolhapur",
      "description": "eTravo offers comprehensive company cab and bus hire services in Kolhapur, designed for businesses of all sizes. Whether you need executive cabs for senior staff or large-capacity buses for daily employee transport, our fleet includes a wide range of air-conditioned vehicles. With transparent pricing, professional chauffeurs, and real-time support, we ensure hassle-free travel for your corporate needs."
    },
    {
      "name": "Corporate Staff Transport Kolhapur",
      "description": "eTravo provides reliable and punctual corporate staff transport solutions in Kolhapur. We help businesses improve workforce productivity by offering structured pickup and drop services, ensuring your employees arrive safely and on time. Our transport plans can be customized by shift timing, location, and fleet size, making it ideal for industries with diverse operational schedules."
    },
    {
      "name": "Bus Services for Office Employees in Kolhapur",
      "description": "Streamline your employee commuting needs with eTravo’s dedicated bus services for office employees in Kolhapur. Our buses are well-maintained, spacious, and equipped with modern amenities. Whether it’s a single route or multi-zone coverage, we handle logistics, scheduling, and safety monitoring so your teams can travel in comfort every day."
    },
    {
      "name": "AC Bus & Cab Rentals for Business in Kolhapur",
      "description": "Enjoy premium travel with eTravo’s AC bus and cab rentals for business use in Kolhapur. Our fleet offers air-conditioned comfort for all corporate occasions, including daily commutes, site visits, executive travel, and intercity meetings. From compact sedans to full-size buses, we provide a vehicle solution for every type of business journey."
    },
    {
      "name": "Affordable Employee Shuttle Kolhapur",
      "description": "Optimize your company's transport budget with eTravo’s affordable employee shuttle services in Kolhapur. Our shuttles are ideal for small and medium-sized enterprises looking to cut costs while ensuring consistent employee mobility. With regular routes, verified drivers, and clean vehicles, we provide a reliable and economical commute for your staff."
    },
    {
      "name": "Daily Commute Solutions for Corporates in Kolhapur",
      "description": "eTravo delivers efficient daily commute solutions for corporates in Kolhapur by offering structured transportation plans for employees. With GPS-enabled tracking, route optimization, shift-based scheduling, and backup vehicles, we ensure continuity, safety, and comfort in your company’s daily mobility operations."
    },
    {
      "name": "Kolhapur Corporate Vehicle Hire",
      "description": "Need dependable vehicles for your corporate transport needs in Kolhapur? eTravo’s corporate vehicle hire service includes cabs, minibuses, and coaches suitable for employee pickups, guest transfers, offsite travel, and more. All our vehicles are maintained to high standards and are operated by trained professionals to deliver a smooth, efficient travel experience."
    }
  ],
  "tableData": [
    ["Company Cab & Bus Hire in Kolhapur", "Corporate Staff Transport Kolhapur"],
    ["Bus Services for Office Employees in Kolhapur", "AC Bus & Cab Rentals for Business in Kolhapur"],
    ["Affordable Employee Shuttle Kolhapur", "Daily Commute Solutions for Corporates in Kolhapur"],
    ["Kolhapur Corporate Vehicle Hire", ""]
  ],







  "whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Corporate Transport",
        "WhyChoosedescription": "eTravo is committed to punctuality. Our corporate cab and bus services in Kolhapur ensure timely travel for employees and executives, helping your business maintain professionalism and efficiency."
    },
    {
        "WhyChooseheading": "Fleet Options to Suit Every Business Need",
        "WhyChoosedescription": "Whether it’s executive cabs for client meetings or buses for team commutes, eTravo offers a modern, air-conditioned fleet tailored for corporate travel in Kolhapur."
    },
    {
        "WhyChooseheading": "Experienced, Courteous Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and familiar with Kolhapur’s routes. They maintain the highest standards of corporate service and ensure a smooth, safe ride every time."
    },
    {
        "WhyChooseheading": "Clear Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer transparent and competitive rates for all corporate cab and bus services in Kolhapur. With eTravo, you get a clear cost structure and complete peace of mind."
    },
    {
        "WhyChooseheading": "Safety First—Always",
        "WhyChoosedescription": "Your team's safety is our top priority. All our vehicles in Kolhapur are equipped with GPS, seat belts, emergency kits, and undergo regular maintenance checks for safe operations."
    },
    {
        "WhyChooseheading": "Available 24/7 to Match Your Schedule",
        "WhyChoosedescription": "eTravo operates round the clock in Kolhapur. Whether it’s an early departure, a late return, or an urgent request, we’re always ready with dependable transport and support."
    },
    {
        "WhyChooseheading": "Fast and Flexible Booking Process",
        "WhyChoosedescription": "Booking a corporate cab or bus in Kolhapur is easy with eTravo. Use our online system or contact our support team for quick scheduling and real-time updates."
    },
    {
        "WhyChooseheading": "Customized Corporate Travel Packages",
        "WhyChoosedescription": "We offer personalized travel plans based on your business needs in Kolhapur—daily employee commutes, corporate events, or intercity transfers. eTravo adapts to your requirements."
    }
]




















    }


   



const faqData = [
    [
        {
            question: 'What corporate transportation services does eTravo offer in Kolhapur?',
            answer: 'eTravo offers end-to-end corporate transportation in Kolhapur, including employee cab services, shuttle buses for staff, VIP transfers, and corporate event travel with professional-grade service.',
        },
        {
            question: 'Can eTravo manage daily pick-up and drop services for employees in Kolhapur?',
            answer: 'Yes, we provide customized, scheduled daily employee transportation using both cabs and buses. Our operations are designed for efficiency, punctuality, and safety.',
        },
        {
            question: 'What vehicle options are available for corporate clients in Kolhapur?',
            answer: 'We offer a variety of well-maintained vehicles — from compact and premium cabs to AC buses and luxury coaches — all tailored to corporate travel requirements.',
        },
        {
            question: 'Does eTravo support live tracking and automated trip reports?',
            answer: 'Absolutely. All our corporate vehicles are GPS-enabled, and clients receive live tracking access along with daily usage summaries and automated compliance reports.',
        },
        {
            question: 'Can we hire eTravo for offsites, meetings, or corporate tours in Kolhapur?',
            answer: 'Yes, eTravo supports flexible bookings for offsite trips, client visits, and corporate meetings. We ensure timely arrivals and professional service for all business transport needs.',
        },
        {
            question: 'Is account support provided for corporate clients in Kolhapur?',
            answer: 'Yes, a dedicated account manager will be assigned to your organization to oversee bookings, coordinate schedules, and provide quick resolution for any issues.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Desai',
        designation: 'Transport Coordinator, PixelGrid Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has been a game changer for managing our employee transport in Kolhapur. Their reliability and attention to detail have saved us time and improved staff satisfaction.”',
    },
    {
        name: 'Ms. Shruti Pawar',
        designation: 'HR Manager, Equinox Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“The cabs and buses provided by eTravo are always clean, punctual, and driven by courteous professionals. They’ve handled our corporate travel needs in Kolhapur seamlessly.”',
    },
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Service in Kolhapur",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-kolhapur.jpg",
  "description": "Book professional Corporate Cab and Bus Services in Kolhapur with eTravo. We provide affordable company cab and bus hire for employee transportation, daily office commutes, and corporate events. Choose from AC vehicles with trained drivers and flexible schedules.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4023"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-service-in-kolhapur"
  }
};







    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Service in Kolhapur | Office Commute & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus service in Kolhapur with eTravo. Affordable AC vehicles for daily office commute, employee transport, and company events. Reliable, clean, and on-time service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Coproratecabandbusserviceinkohlapur;